import styled from 'styled-components'
import devices from '../../../devices'

export const Container = styled.div`
  //position: relative;
  margin-right: 30px;
  margin-left: 30px;
  
  @media ${devices.mobileL} { 
      margin-right: 3px;
      margin-left: 3px;
  }
  @media ${devices.tablet} { 
      margin-right: 3px;
      margin-left: 3px;
  }
  @media ${devices.laptop} { 
      margin-right: 5px;
      margin-left: 5px;
  }
  
  a{
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: right;
    color: #4378FF;
    padding: 11px 24px;
    border-radius: 8px;
  }
  
  a.active{
    color: #000000;
  }
  
  a:hover{
    background-color: #EFF2F5;
  }
`

export const Title = styled.div`
  color: #4378FF;
  cursor: pointer;
  height: 56px;
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  font-size: 14px;
  font-weight: 700;
  
  &.active{
    color: #000;
  }

`

export const Popup = styled.div`
  box-shadow: 0 5px 32px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  display: ${props => props.open ? 'block' : 'none'};
  position: absolute;
  top: ${props => props.top};
  right: ${props => props.right};
  width: ${props => props.width};
  background-color: #fff;
  z-index: 1000000;
  
  h3 {
    font-size: 14px;
    line-height: 18px;
    opacity: 0.5;
  }
`

export const NotificationDivider = styled.div`
  margin: 5px 0;
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #D0D1D7
`

export const NotificationRow = styled.div`
  flex-basis: 100%;
  min-height: 30px;
  cursor: pointer;
  padding: 8px 16px;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  border-radius: 8px;
  display: flex;
  flex-direction: column;


  &:hover{
    background-color: #F5F5F5;
  }
  &:after{
    border: 1px solid #D0D1D7;
  }
`

export const NotificationMainRow = styled.div`
  
`

export const NotificationDateRow = styled.span`
  margin-top: 5px;
`

export const Links = styled.div`
  padding: 10px 20px;

  a {
    text-align: left;
    font-size: 14px;
    color: #4378FF;
    margin-bottom: 10px;
    display: block;
    text-decoration: none;

    &.active{
      color: #000000;
    }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`


